import React from 'react';
import linkTag2Initializer from '../../util/linkTag2Initializer';
import { appContext } from '../../util/decorators';
import EnetpulseWidget from '../EnetpulseWidget.jsx';
import PageWithSidebars from '../Page/PageWithSidebars.jsx';
import { connect } from 'react-redux';

const mapStateToProps = state => ({
  sport: state.routeParams.sports,
  id: state.routeParams.id,
});

@connect(mapStateToProps)
@linkTag2Initializer()
@appContext
export default class WidgetIndex extends React.PureComponent {
  render() {
    const t = this.context.app.t;
    const { route: { widgetType }, sport, id } = this.props;

    return (
      <PageWithSidebars>
        <section className="widget-page">
          <div className="page-heading">
            <h2>{t(`WidgetIndex.${widgetType}`)}</h2>
          </div>
          <EnetpulseWidget sport={sport} widgetType={widgetType} params={id} className="margin-top" />
        </section>
      </PageWithSidebars>
    );
  }
}

WidgetIndex.propTypes = {
  route: React.PropTypes.object,
  sport: React.PropTypes.string,
  id: React.PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/component/WidgetPages/WidgetIndex.jsx